/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect, useState } from 'react';
import AccessDenied from '../components/AccessDenied';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserInfo } from '../reducers/User/actions';
import PageLoader from '../components/PageLoader';

interface Props {
  children: React.ReactNode;
}

const CheckPermission: FC<Props> = ({ children }) => {
  const [isPermitted, setIsPermitted] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const history = useLocation();
  const pathname = history.pathname;
  const userInfo: any = useSelector(getUserInfo);

  const permissions = (userInfo?.permissions || []).filter((permission: any) => permission.type === 'page');

  useEffect(() => {
    const isAllowed = permissions.find((permission: any) => {
      const regex = new RegExp(permission.url);
      return regex.test(pathname);
    });
    if (isAllowed) {
      setIsPermitted(isAllowed.allow);
    } else setIsPermitted(true);
    setIsChecking(false);

    return () => {
      setIsChecking(true);
    };
  }, [pathname, permissions]);

  if (isChecking) {
    return <PageLoader />;
  }

  if (!isPermitted) {
    return <AccessDenied />;
  }

  return <>{children}</>;
};

export default CheckPermission;
